/** Firebase errors carry a `code` (e.g. `auth/invalid-app-credential`) that's more useful than the message. */
export function logError(context: string, err: unknown): void {
  const code = typeof err === 'object' && err !== null ? (err as { code?: string }).code : undefined
  const message = err instanceof Error ? err.message : String(err)
  console.error(`[${context}]`, code ? `${code} — ${message}` : message, err)
}
